module.exports = __webpack_public_path__ + "staticVue/img/shipping-company.c818205a.png";